import React from 'react';

import withStyles from '@mui/styles/withStyles';

import DA from '../store/ReduxAccess';

import activityPanelStyles from '../assets/jss/crm/components/activityPanelStyles';

import ConfirmModal from './ConfirmModal';
import CrmButton from './CrmButton';
import CrmTextField from './CrmTextField';

/*
Call with
<NoteCreationPanel
  noteId={0 for new note}
  noteCreationFunc={(noteText) => function(noteText)} // to create or update the note in whatever context, calling /api/note, etc.
  noteDeletionFunc={function} // to delete the note and close the modal.
/>
*/

class NoteCreationPanel extends React.Component {
  state = {
    noteText: '',
  };

  componentDidMount() {
    const noteId = this.props.noteId;
    if (noteId) {
      const note = DA.getNoteWithId(noteId);
      this.setState({ noteText: note.content });
    }
  }

  handleNewNoteChange(newVal) {
    this.setState({ noteText: newVal });
  }

  clearText() {
    this.setState({ noteText: '' });
  }

  offerToDeleteNote() {
    const q = 'Are you sure you want to delete this note?';
    this.setState({
      shouldShowDeletionConfirmationModal: true,
      deletionConfirmationQuery: q,
      deleteFunc: () => this.props.noteDeletionFunc(),
    });
  }

  saveNote() {
    this.props.noteCreationFunc(this.state.noteText.trim());
    this.setState({ noteText: '' });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <ConfirmModal
          show={this.state.shouldShowDeletionConfirmationModal}
          title="Confirm Deletion"
          confirmButtonLabel="Delete"
          rejectButtonLabel="Cancel"
          onConfirm={this.state.deleteFunc}
          onReject={() => this.setState({ shouldShowDeletionConfirmationModal: false })}
        >
          <div>{this.state.deletionConfirmationQuery}</div>
        </ConfirmModal>

        <div className={classes.activityPanel_content}>
          <CrmTextField
            label="Type note here"
            fullWidth
            multiline
            value={this.state.noteText}
            onChange={(event) => this.handleNewNoteChange(event.target.value)}
          />
        </div>
        {this.state.noteText.trim().length > 0 && (
          <div className={classes.u_alignRight}>
            {!!this.props.noteId && (
              <CrmButton outlined onClick={() => this.offerToDeleteNote()}>
                Delete
              </CrmButton>
            )}
            <CrmButton outlined onClick={() => this.clearText()}>
              Clear{' '}
            </CrmButton>
            <CrmButton filled onClick={() => this.saveNote()}>
              Save
            </CrmButton>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(activityPanelStyles)(NoteCreationPanel);
